import { IAppointmentsReport } from '../../interface/IAppointmentsReport'
import { IAPIAppointmentsReport } from '../interface/IAPIAppointmentsReport'
import { TGroupBy } from '../types/TGroupBy'

import { formatForMonth } from './utils/formatForMonth'
import { formatForWeek } from './utils/formatForWeek'
import { formatForYear } from './utils/formatForYear'

export const appointmentsReportTransformer = (
    apiData: IAPIAppointmentsReport[],
    groupBy: TGroupBy
): IAppointmentsReport[] | null => {
    if (apiData.length === 0) {
        return null
    }

    switch (groupBy) {
        case 'week':
            return formatForWeek(apiData)
        case 'month':
            return formatForMonth(apiData)
        case 'year':
            return formatForYear(apiData)
    }
}
